import { createClient } from "@supabase/supabase-js"

const supabaseUrl  = (import.meta as Record<string, any>).env.VITE_SUPABASE_URL  as string
const supabaseKey  = (import.meta as Record<string, any>).env.VITE_SUPABASE_ANON_KEY as string

export const supabase = createClient(supabaseUrl, supabaseKey)
export const signOut = async () => {
  await supabase.auth.signOut();
};
export const logAuditAction = async (
  _action: string,
  _targetId: string,
  _message: string,
  _metadata?: string
): Promise<void> => {
  return;
};